import Vue from 'vue'
import Vuex from 'vuex'
import globalModule from './modules/global'
import dialerModule from './modules/dialer'
import conferenceModule from './modules/conference'
import LogRocket from 'logrocket'
import createPlugin from 'logrocket-vuex'

Vue.use(Vuex)
const logrocketPlugin = createPlugin(LogRocket)

export default new Vuex.Store({
  modules: {
    global: globalModule,
    dialer: dialerModule,
    conference: conferenceModule
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [logrocketPlugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js